// JsFromRoutes CacheKey 724aa4072b2d05ee17f44f8a890a836a
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  new: /* #__PURE__ */ definePathHelper('get', '/password/reset'),
  edit: /* #__PURE__ */ definePathHelper('get', '/password/change'),
  update: /* #__PURE__ */ definePathHelper('patch', '/password'),
  create: /* #__PURE__ */ definePathHelper('post', '/password'),
}
